
<div :class="jel_getClassObject(content)">
  <div>
    <div
      v-if="isSpinnerVisible"
      id="spinner"
      class="d-flex flex-column justify-content-center align-items-center text-center"
    >
      <b-spinner :label="$t('chargement')"></b-spinner>
    </div>
    <div class="row">
      <div class="col text-left">
        <!-- Liste Avis -->
        <template v-if="!isErreurServeur">
          <div v-if="messages.length" class="avis-view">
            <div
              class="avis-list"
              :class="{ 'avis-list--hidden': isListHidden && !isDesktopLayout }"
              :inert="isListInactive"
            >
              <button
                v-for="(messageAvis, index) in visibleMessages"
                :key="
                  messageAvis.id ||
                  `${messageAvis.messageCode}-${messageAvis.createDate}-${index}`
                "
                :ref="`avis-${messageAvis.id}`"
                type="button"
                class="avis-list__item"
                :class="{
                  'avis-list__item--unread': !messageAvis.readDate,
                  'avis-list__item--read': Boolean(messageAvis.readDate),
                  'avis-list__item--selected': isSelected(messageAvis),
                }"
                :aria-expanded="isSelected(messageAvis) ? 'true' : 'false'"
                :tabindex="isListInactive ? -1 : 0"
                :disabled="isMessageIndisponible(messageAvis)"
                @click="openMessage(messageAvis)"
              >
                <span class="avis-list__text">
                  <span class="avis-list__title">{{ getMessageTitle(messageAvis) }}</span>
                  <time class="avis-list__date" :datetime="messageAvis.createDate">
                    {{ formatMessageDate(messageAvis.createDate) }}
                  </time>
                </span>
                <span
                  v-if="!isMessageIndisponible(messageAvis)"
                  class="avis-list__chevron"
                  aria-hidden="true"
                ></span>
              </button>

              <button
                v-if="showLoadMore"
                type="button"
                class="avis-load-more"
                :disabled="isLoadingMore"
                :tabindex="isListInactive ? -1 : 0"
                @click="loadMoreMessages"
              >
                <b-spinner v-if="isLoadingMore" small :label="$t('chargement')"></b-spinner>
                <span v-else>{{ loadMoreLabel }}</span>
              </button>
              <button
                v-else-if="showLoadLess"
                type="button"
                class="avis-load-more"
                :tabindex="isListInactive ? -1 : 0"
                @click="showInitialMessages"
              >
                {{ loadLessLabel }}
              </button>
            </div>
            <transition
              name="avis-detail-panel"
              @after-enter="setBackButtonFocus"
              @after-leave="restoreListFocus"
            >
              <section
                v-if="selectedMessage || isDesktopLayout"
                key="detail"
                class="avis-detail"
                aria-live="polite"
              >
                <button
                  v-if="selectedMessage"
                  ref="backButton"
                  type="button"
                  class="avis-detail__back"
                  :aria-label="$t('avisBienJouer.retourListeAria')"
                  @click="closeMessage"
                >
                  <span class="avis-detail__back-chevron" aria-hidden="true"></span>
                  <span>{{ $t('avisBienJouer.retourListe') }}</span>
                </button>

                <div v-if="selectedMessage" class="avis-detail__box">
                  <time class="avis-detail__date" :datetime="selectedMessage.createDate">
                    {{ formatMessageDate(selectedMessage.createDate) }}
                  </time>
                  <h3 class="avis-detail__title">{{ getMessageTitle(selectedMessage) }}</h3>
                  <div class="Paragraphe" v-html="getMessageDetail(selectedMessage)" />
                </div>
                <div v-else class="avis-detail__box avis-detail__box--empty">
                  <svg-icon icon-name="ic-enveloppe-bien-jouer" class="avis-detail__empty-icon" />
                  <p class="avis-detail__empty-text">
                    {{ $t('avisBienJouer.selectionnerMessage') }}
                  </p>
                </div>
              </section>
            </transition>
          </div>

          <p v-else-if="!isSpinnerVisible" class="avis-empty">
            {{ $t('avisBienJouer.aucunAvis') }}
          </p>
        </template>
        <div v-else>
          <MessageMel
            v-show="contentMessageMel.message"
            :content="contentMessageMel.message"
            class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
          ></MessageMel>
        </div>
      </div>
    </div>
  </div>
</div>
